export default {"src":"/_next/static/media/product.ba64d04a.svg","height":210,"width":270,"blurWidth":0,"blurHeight":0};